module.exports = __webpack_public_path__ + "img/member_lip3.03376646.png";